export type PreviewRefundType = {
	startDate: string;
	protocol: string;
	protocolCode: string;
	request: string;
	requestCode: string;
	protocolSituationCode: ConsultPreviewRefundEnum;
	ansProtocol: string;
	requestDetails: RequestDetailType[];
	patientCode: string;
};

export type RequestDetailType = {
	patient: string;
	registeredDate: string;
	request: string;
	requestCode: string;
	requestDate: string;
};

export type GetConsultPreviewRefundsModel = {
	content: {
		consultRefunds: PreviewRefundType[];
		total: number;
		totalPerPage: number;
	};
};

export type GetConsultPreviewRefundsParams = {
	patientCode?: string;
	userCode?: string;
	startDate?: string;
	endDate?: string;
	limit?: number;
	page?: number;
};

export enum ConsultPreviewRefundEnum {
	REGISTERED = 1,
	REGISTERED_ALT = 3,
	CANCELED = 4,
	DENIED = 5,
	IN_ANALYSIS = 6,
	APPROVED = 7,
}

export interface GetConsultPreviewRefunds {
	get: (params?: GetConsultPreviewRefundsParams) => Promise<GetConsultPreviewRefundsModel>;
}
